import React, { memo } from 'react';
import { FieldColorNames } from 'Hooks/DocumentFields/useDocumentFieldColor';
import { DocumentFieldTypes } from 'Interfaces/DocumentFields';
import { RequisiteType } from 'Interfaces/Requisite';
import { interactFieldInitialFont } from 'Services/Fonts';

import {
  CheckboxField,
  DateField,
  NameField,
  RequisiteField,
  TextFieldSign,
} from './FieldTypes';

interface FieldItemDefaultTriggerProps {
  fieldType: DocumentFieldTypes;
}

const FieldItemDefaultTrigger = ({ fieldType }: FieldItemDefaultTriggerProps) => {
  switch (fieldType) {
    case DocumentFieldTypes.Name: {
      return (
        <NameField
          fieldColor={FieldColorNames.EMPTY}
          disabled
          style={interactFieldInitialFont}
        />
      );
    }
    case DocumentFieldTypes.Signature:
    case DocumentFieldTypes.Initials: {
      return (
        <RequisiteField
          fieldColor={FieldColorNames.EMPTY}
          requisiteType={
            fieldType === DocumentFieldTypes.Signature
              ? RequisiteType.SIGN
              : RequisiteType.INITIAL
          }
          disabled
        />
      );
    }
    case DocumentFieldTypes.Checkbox: {
      return <CheckboxField disabled fieldColor={FieldColorNames.EMPTY} />;
    }
    case DocumentFieldTypes.Text: {
      return (
        <TextFieldSign
          disabled
          fieldColor={FieldColorNames.EMPTY}
          style={interactFieldInitialFont}
        />
      );
    }
    case DocumentFieldTypes.Date: {
      return (
        <DateField
          fieldColor={FieldColorNames.EMPTY}
          disabled
          style={interactFieldInitialFont}
        />
      );
    }
    default: {
      return null;
    }
  }
};

FieldItemDefaultTrigger.displayName = FieldItemDefaultTrigger.name;

export default memo<FieldItemDefaultTriggerProps>(FieldItemDefaultTrigger);
